import {
  IdentificationProvider,
  TVerificationAppElement,
  VerificationAppDocumentType,
} from "../../app/models";
import { TDocument } from "../models";

export const ADDABLE_AMLBOT_DOC_ONLY_IDENTIFICATION_DOCUMENT_TYPES = [
  VerificationAppDocumentType.Passport,
  VerificationAppDocumentType.Id,
] as const;

const EDITABLE_DOCUMENT_TYPES = new Set<string>(
  ADDABLE_AMLBOT_DOC_ONLY_IDENTIFICATION_DOCUMENT_TYPES,
);

export function getEffectiveIdentificationProvider(
  identificationProvider?: IdentificationProvider,
): IdentificationProvider {
  return identificationProvider || IdentificationProvider.AMLBOT;
}

export function isAmlbotDocOnlyIdentificationStep(
  stepConfig: TVerificationAppElement,
  identificationProvider?: IdentificationProvider,
): boolean {
  return (
    stepConfig.type === VerificationAppDocumentType.Identification &&
    getEffectiveIdentificationProvider(identificationProvider) ===
      IdentificationProvider.AMLBOT &&
    stepConfig.amlbot?.format === "doc_only"
  );
}

export function canEditIdentificationDocumentPayload(
  stepConfig: TVerificationAppElement,
  document: TDocument,
  canEdit: boolean,
  identificationProvider?: IdentificationProvider,
): boolean {
  return (
    canEdit &&
    isAmlbotDocOnlyIdentificationStep(stepConfig, identificationProvider) &&
    EDITABLE_DOCUMENT_TYPES.has(document.document.documentType)
  );
}
